module.exports = __webpack_public_path__ + "img/normal-visual.84826022.png";